import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Commodities from "./pages/Commodities";
import Countries from "./pages/Countries";
import Insights from "./pages/Insights";
import Emissions from "./pages/Emissions";
import EnergiaIQ from "./pages/EnergiaIQ";
import OurStory from "./pages/about/OurStory";
import OurPeople from "./pages/about/OurPeople";
import OurValues from "./pages/about/OurValues";
import OurCulture from "./pages/about/OurCulture";
import OurCustomers from "./pages/about/OurCustomers";
import OurLocations from "./pages/about/OurLocations";
// Legal Pages
import Disclaimer from "./pages/legal/Disclaimer";
import TermsOfService from "./pages/legal/TermsOfService";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import CookiePolicy from "./pages/legal/CookiePolicy";
import AntiSlaveryPolicy from "./pages/legal/AntiSlaveryPolicy";
import ContactPage from "./pages/ContactPage";
import Reports from "./pages/Reports";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/story" element={<OurStory />} />
          <Route path="/about/people" element={<OurPeople />} />
          <Route path="/about/values" element={<OurValues />} />
          <Route path="/about/culture" element={<OurCulture />} />
          <Route path="/about/customers" element={<OurCustomers />} />
          <Route path="/about/locations" element={<OurLocations />} />
          <Route path="/commodities" element={<Commodities />} />
          <Route path="/countries" element={<Countries />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/emissions" element={<Emissions />} />
          <Route path="/energia-iq" element={<EnergiaIQ />} />
          <Route path="/reports" element={<Reports />} />
          {/* Legal Pages */}
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/anti-slavery-policy" element={<AntiSlaveryPolicy />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
